// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__xEcJj","input":"Checkbox_input__uRSy8","label":"Checkbox_label__scbRi","disabled":"Checkbox_disabled__fii9J"};